<template lang="html">
	<div class="testimonials">
		<div class="row justify-content-center">
			<div class="col-12 col-md-11 col-lg-10 col-xl-9">
				<div class="title">Testimonials</div>

				<div class="carousel-box">
					<hooper :settings="settings">
						<slide
							v-for="(testimonial, i) in testimonials"
							:key="i"
						>
							<div class="testimonial-card">
								<div class="row justify-content-center">
									<div class="col-sm-4 image-box">
										<div class="clearfix">
											<img
												:src="testimonial.image"
												alt=""
												class="avatar"
											/>
										</div>
										<div class="name">
											{{ testimonial.name }}
										</div>
										<div class="position">
											{{ testimonial.position }}
										</div>
									</div>
									<div class="col-sm-8 description-box">
										<div class="small-title">
											{{ testimonial.title }}
										</div>
										<div class="desc">
											{{ testimonial.desc }}
										</div>
									</div>
								</div>
							</div>
						</slide>

						<hooper-pagination
							slot="hooper-addons"
						></hooper-pagination>
					</hooper>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Hooper, Slide, Pagination as HooperPagination } from 'hooper';
export default {
	components: {
		Hooper,
		Slide,
		HooperPagination,
	},
	data() {
		return {
			settings: {
				autoPlay: true,
				infiniteScroll: true,
				playSpeed: 12000,
				itemsToShow: 3,
			},
		};
	},
	computed: {
		...mapGetters(['loading', 'testimonials']),
	},
	methods: {
		...mapActions(['sendMessage']),
	},
	mounted() {},
};
</script>

<style lang="less">
@media (max-width: 992px) {
	.testimonials {
		.hooper-slide {
			width: 100% !important;

			.testimonial-card {
				.image-box {
					.clearfix {
						display: flex;
						justify-content: center;

						.avatar {
							text-align: center;
						}
					}
					.name,
					.position {
						text-align: center !important;
					}
				}
				.description-box {
					margin: 20px 0 0 0;
					display: block !important;

					.small-title {
						margin: 0 0 10px 0 !important;
					}
				}
			}
		}
	}
}
.testimonials {
	background-color: var(--white);
	padding: 150px 0 90px 0;

	.carousel-box {
		max-width: 100vw !important;
		overflow-x: hidden;
	}
	.title {
		font-size: 26px;
		opacity: 0.6;
		font-family: var(--font-bold);
		text-align: center;
	}

	.hooper,
	.hooper-list {
		height: auto;

		.hooper-pagination {
			.hooper-indicator {
				background-color: rgba(134, 142, 156, 0.3);
				width: 6px;
				height: 6px;

				&.is-active {
					background: var(--primary);
				}
			}
		}
	}
	.hooper-slide {
		// width: auto !important;
		// width: 100% !important;
		height: auto;

		.testimonial-card {
			margin: 120px 0 150px 0;

			.image-box {
				flex: 0 0 75%;
				max-width: 75%;

				.avatar {
					width: 80px;
					height: auto;
					border-radius: 20px;
					float: right;
					margin: 0 0 20px 0;
				}

				.name {
					font-weight: 600;
					text-align: right;
				}
				.position {
					text-align: right;
					font-size: 13px;
				}
			}

			.description-box {
				padding-left: 20px;
				display: none;

				.small-title {
					font-size: 32px;
					line-height: 40px;
					margin: 0 0 20px 0;
				}
				.desc {
					font-size: 15px;
				}
			}
		}

		&.is-current {
			.testimonial-card {
				.description-box {
					display: block;
				}
			}
			.image-box {
				flex: 0 0 33.33333%;
				max-width: 33.33333%;
			}
		}
	}
}
</style>
